import React, { useEffect, useRef } from 'react';
import './HowItWorks.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCheck, faBoxes, faChartBar, faFileAlt, faVideo, faFilePdf, faPeopleCarryBox, faMoneyBill, faLock, faCloud } from '@fortawesome/free-solid-svg-icons';

const HowItWorks = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentRef = sectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const handleVideoClick = () => {
    window.open('https://drive.google.com/file/d/1Bd9jX1TYwcrIrgA8aTTbxK4cgAVo1vsd/view?usp=sharing', '_blank'); // Reemplaza con la URL de tu video
  };

  const handlePdfClick = () => {
    window.open('/img/Punto Central.pdf', '_blank'); // Reemplaza con la URL de tu PDF
  };

  return (
    <div className="how-it-works" ref={sectionRef}>
      <h2 className="section-title">Cómo Funciona Nuestro Sistema</h2>
      <div className="how-it-works-container">
        <div className="features-column">
          <div className="step-card">
            <FontAwesomeIcon icon={faUserCheck} className="step-icon" />
            <h3>Inicio de sesion seguro por roles</h3>
          </div>
          <div className="step-card">
            <FontAwesomeIcon icon={faBoxes} className="step-icon" />
            <h3>Gestión de Inventario</h3>
          </div>
          <div className="step-card">
            <FontAwesomeIcon icon={faPeopleCarryBox} className="step-icon" />
            <h3>Guias de Reparto</h3>
          </div>
          <div className="step-card">
            <FontAwesomeIcon icon={faCloud} className="step-icon" />
            <h3>Acceso en la Nube</h3>
          </div>
        </div>

        <div className="image-container">
          <img src="img/funciones.png" alt="Sistema" className="center-image" />
        </div>

        <div className="features-column">
          <div className="step-card">
            <FontAwesomeIcon icon={faChartBar} className="step-icon" />
            <h3>Análisis y Reportes</h3>
          </div>
          <div className="step-card">
            <FontAwesomeIcon icon={faFileAlt} className="step-icon" />
            <h3>Factura electronica o impresa</h3>
          </div>
          <div className="step-card">
            <FontAwesomeIcon icon={faMoneyBill} className="step-icon" />
            <h3>Registra las Deudas de los clientes</h3>
          </div>
          <div className="step-card">
            <FontAwesomeIcon icon={faLock} className="step-icon" />
            <h3>Seguridad y Protección de Datos</h3>
          </div>
        </div>
      </div>

      {/* Sección de botones para ver el video y el PDF */}
      <div className="buttons-container">
        <button className="custom-button" onClick={handleVideoClick}>
          <FontAwesomeIcon icon={faVideo} className="button-icon" /> Ver Video Del Producto
        </button>
        <button className="custom-button" onClick={handlePdfClick}>
          <FontAwesomeIcon icon={faFilePdf} className="button-icon" /> Ver Documentacion
        </button>
      </div>
    </div>
  );
};

export default HowItWorks;



